import css from './TopExercises.module.css';

interface Row {
  exercise_id: string;
  name: string | null;
  region: string | null;
  sets: number;
  sessions: number;
  last_seen: string;
}

export function TopExercises({ data }: { data: Row[] }) {
  if (data.length === 0) {
    return <div className={css.empty}>No exercises logged.</div>;
  }
  return (
    <table className={css.table}>
      <thead>
        <tr>
          <th className={css.thLeft}>Exercise</th>
          <th className={css.thRight}>Sets</th>
          <th className={css.thRight}>Sessions</th>
          <th className={css.thRight}>Last seen</th>
        </tr>
      </thead>
      <tbody>
        {data.map((r) => (
          <tr key={r.exercise_id}>
            <td className={css.name}>
              <div>{r.name ?? r.exercise_id}</div>
              {r.region && <div className={css.region}>{r.region}</div>}
            </td>
            <td className={css.num}>{r.sets.toLocaleString('en')}</td>
            <td className={css.num}>{r.sessions.toLocaleString('en')}</td>
            <td className={css.num}>{r.last_seen}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
